import { useParams, Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { authorsApi } from '../api/authors'
import { sourcesApi } from '../api/sources'

export const AuthorDetailPage = () => {
  const { id } = useParams<{ id: string }>()
  const authorId = Number(id)

  const { data: author, isLoading: isLoadingAuthor } = useQuery({
    queryKey: ['authors', authorId],
    queryFn: () => authorsApi.getAuthor(authorId),
    enabled: !!authorId,
  })

  const { data: allSources, isLoading: isLoadingSources } = useQuery({
    queryKey: ['sources'],
    queryFn: () => sourcesApi.getSources(),
  })

  const sources = allSources?.filter((s) => s.authors?.some((a) => a.id === authorId)) ?? []

  const initials = author?.name.split(' ').map((p: string) => p[0]).slice(0, 2).join('').toUpperCase() ?? ''

  if (isLoadingAuthor) return <p>Laden...</p>
  if (!author) return <p>Autor nicht gefunden.</p>

  return (
    <div>
      <div style={{ marginBottom: '0.5rem' }}>
        <Link to="/authors" style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', textDecoration: 'none' }}>
          ← Alle Autoren
        </Link>
      </div>

      <div className="card" style={{ marginBottom: '2rem', padding: '1.25rem 1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div style={{
            width: 52, height: 52, borderRadius: '50%',
            background: 'var(--primary)', color: 'white',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 600, fontSize: '1rem', flexShrink: 0, letterSpacing: '0.02em',
          }}>
            {initials}
          </div>
          <h2 style={{ margin: 0 }}>{author.name}</h2>
        </div>
      </div>

      <h3 style={{ marginBottom: '1rem' }}>
        Quellen {!isLoadingSources && `(${sources.length})`}
      </h3>

      {isLoadingSources ? (
        <p>Laden...</p>
      ) : sources.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {sources.map((s) => (
            <Link
              key={s.id}
              to={`/sources/${s.id}`}
              style={{ textDecoration: 'none' }}
            >
              <div className="card" style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.875rem 1.125rem', marginBottom: 0 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 'var(--radius-sm)',
                  background: s.type === 'book' ? 'var(--primary)' : '#6b7280',
                  color: 'white', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: '1.1rem', flexShrink: 0,
                }}>
                  {s.type === 'book' ? '📖' : '📄'}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, color: 'var(--text-primary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {s.title}
                  </div>
                  {s.year && (
                    <div style={{ fontSize: '0.8125rem', color: 'var(--text-secondary)', marginTop: '0.2rem' }}>
                      {s.year}{s.publisher && ` · ${s.publisher}`}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>Keine Quellen gefunden.</p>
        </div>
      )}
    </div>
  )
}
